"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _UINumberInput = _interopRequireDefault(require("UIComponents/input/UINumberInput"));

var _UICurrencyInput = _interopRequireDefault(require("UIComponents/input/UICurrencyInput"));

var _QuestionEntityRecord = _interopRequireDefault(require("../QuestionEntityRecord"));

function unformattedFormatter(value) {
  if (value === null || value === undefined) {
    return '';
  }

  return "" + value;
}

var PropertyNumberInput = function PropertyNumberInput(_ref) {
  var question = _ref.question,
      objectProperty = _ref.objectProperty,
      _onChange = _ref.onChange,
      disabled = _ref.disabled;
  var Input = _UINumberInput.default;
  var formatProps = {};

  if (question.isCurrency()) {
    Input = _UICurrencyInput.default;
    formatProps = {
      currency: question.currencyCode
    };
  } else if (objectProperty.get('numberDisplayHint') === 'unformatted') {
    formatProps = {
      formatter: unformattedFormatter
    };
  }

  return _react.default.createElement(Input, (0, _extends2.default)({
    value: question.getValue(),
    disabled: disabled,
    onChange: function onChange(event) {
      return _onChange(event.target.value);
    },
    placeholder: _I18n.default.text('composer-plugins.questionAndAnswer.propertyPlaceholders.textInput')
  }, formatProps));
};

PropertyNumberInput.propTypes = {
  onChange: _react.PropTypes.func.isRequired,
  disabled: _react.PropTypes.bool.isRequired,
  question: _react.PropTypes.instanceOf(_QuestionEntityRecord.default).isRequired,
  objectProperty: _react.PropTypes.instanceOf(_immutable.Map).isRequired
};
var _default = PropertyNumberInput;
exports.default = _default;
module.exports = exports.default;